// @flow

import type { SpecialContactsState } from "./types";

export const initialState: SpecialContactsState = {
  requestsInProgress: 0,
  list: {
    content: [],
    pagination: {
      sort: { orders: [] },
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
    totalElements: 0,
  },
  listOptions: {
    page: 1,
    search: {},
    sort: { id: "employeeReference", direction: "asc" },
  },
  current: null,
  employeesList: null,
  modals: {
    showAddModal: false,
    showEditModal: false,
    showDeleteModal: false,
  },
};

export default initialState;
